import Vue from "vue"
import VueI18n from "vue-i18n"
import getLocale from "@/utils/locale"
import ShowPassword from "@/shared/show-password"

Vue.use(VueI18n)

export default () => {
  const passwordFields = document.querySelectorAll(".vue-password-field")
  passwordFields.forEach((field, index) => {
    new Vue({
      name: "PasswordFieldApp",
      el: field,
      i18n: new VueI18n({ locale: getLocale() }),
      components: { ShowPassword },
      template: `<show-password
        name='reset_password[password${index + 1}]'
        :class='"reset-password__field"' />`
    })
  })
}
